'use client';

var _excluded = ["children", "className", "node", "onDownload", "onPreviewOpen"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { UploadcareImage } from '@prezly/uploadcare';
import classNames from 'classnames';
import { useMemo, useState } from 'react';
import { Lightbox, Media, Rollover } from "../../components/index.mjs";
import { stringifyNode } from "../../lib/index.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function getContainerStyle(node) {
  if (node.layout !== 'contained') {
    return {};
  }
  var maxWidth = "".concat(node.file.original_width, "px");
  var unit = node.width.slice(-1) === '%' ? '%' : 'px';
  if (unit === '%' && parseFloat(node.width).toFixed(2) === Number(100).toFixed(2)) {
    return {
      maxWidth
    };
  }
  return {
    width: node.width,
    maxWidth
  };
}
var NEW_TAB_ATTRIBUTES = {
  target: '_blank',
  rel: 'noopener noreferrer'
};
export function Image(_ref) {
  var _node$new_tab;
  var {
      children,
      className,
      node,
      onDownload,
      onPreviewOpen
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var {
    file,
    href,
    align,
    layout
  } = node;
  var isNewTab = (_node$new_tab = node.new_tab) !== null && _node$new_tab !== void 0 ? _node$new_tab : true;
  var title = stringifyNode(node).trim();
  var containerStyle = getContainerStyle(node);
  var [isPreviewOpen, setIsPreviewOpen] = useState(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  var image = useMemo(() => UploadcareImage.createFromPrezlyStoragePayload(file), [file.uuid]);
  function handleRolloverClick() {
    setIsPreviewOpen(true);
  }
  function handleImagePreviewClose() {
    setIsPreviewOpen(false);
  }
  return /*#__PURE__*/_jsxs("figure", _objectSpread(_objectSpread({
    className: classNames('prezly-slate-image', className, {
      'prezly-slate-image--contained': layout === 'contained',
      'prezly-slate-image--expanded': layout === 'expanded',
      'prezly-slate-image--full-width': layout === 'full-width',
      'prezly-slate-image--align-left': align === 'left',
      'prezly-slate-image--align-right': align === 'right'
    })
  }, props), {}, {
    children: [href && /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
      id: "image-".concat(file.uuid),
      href: href,
      className: "prezly-slate-image__link"
    }, isNewTab ? NEW_TAB_ATTRIBUTES : {}), {}, {
      style: containerStyle,
      children: /*#__PURE__*/_jsx(Media, {
        className: "prezly-slate-image__media",
        image: image,
        title: title
      })
    })), !href && /*#__PURE__*/_jsx(Rollover, {
      id: "image-".concat(file.uuid),
      disabled: image.isGif(),
      href: image.cdnUrl,
      onClick: handleRolloverClick,
      style: containerStyle,
      children: /*#__PURE__*/_jsx(Media, {
        className: "prezly-slate-image__media",
        image: image,
        title: title
      })
    }), title && /*#__PURE__*/_jsx("figcaption", {
      className: "prezly-slate-image__caption",
      children: children
    }), /*#__PURE__*/_jsx(Lightbox, {
      image: isPreviewOpen ? image : null,
      onClose: handleImagePreviewClose,
      onDownload: onDownload,
      onOpen: onPreviewOpen,
      title: title,
      children: children
    })]
  }));
}